import { styled } from "@mui/material";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";

import { PopupActionButton } from "../PopupButtons";
import { modalTransitionProps } from "../ScaleTransition";
import { CircularIcon, ConnectBody, DialogInfo, IconContainer, SignInBody, SignInTitle } from "./dialogStyles";

interface SearchNoResultsDialogProps {
  // The searched term; the dialog is open while it is set.
  term: string | null;
  onClose: () => void;
}

// Header search found nothing (or the lookup failed). Same card as the
// connect-wallet dialog: floating badge, centred title, grey subtitle, one pill CTA.
export const SearchNoResultsDialog = ({ term, onClose }: SearchNoResultsDialogProps) => (
  <DialogInfo
    open={term !== null}
    onClose={onClose}
    {...modalTransitionProps}
    // Same width as the connect-wallet dialog.
    sx={{ "& .MuiDialog-paper": { maxWidth: "min(440px, 90%)", width: "100%" } }}
    aria-labelledby="search-no-results-title"
  >
    <IconContainer>
      <CircularIcon>
        <SearchOffRoundedIcon fontSize="large" color="inherit" />
      </CircularIcon>
    </IconContainer>
    <ConnectBody>
      <SignInTitle id="search-no-results-title">
        Oops! Nothing found for <Term>&ldquo;{term}&rdquo;</Term>
      </SignInTitle>
      <SignInBody>Try a land name, location, EFT ID or wallet address.</SignInBody>
      <PopupActionButton onClick={onClose} variant="contained" fullWidth>
        Try again
      </PopupActionButton>
    </ConnectBody>
  </DialogInfo>
);

// A long pasted term (an address, a sentence) must wrap inside the card, not widen it.
const Term = styled("span")({
  overflowWrap: "anywhere",
});

export default SearchNoResultsDialog;
